import React, { useContext, useState, useCallback } from "react";
import { DF_OT0050Context } from "../../context";
import { Row, Col, Button, Input, Label, FormGroup } from "reactstrap";
import BizinBackend from "../../../../helpers/bizin_helper";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";

const inputClassName = "rounded font-size-14 border-color-cinza2";

export default function GridBody({ idEmpresa }) {
  const { setisLoading, setTriggerOnFilter } =
    useContext(DF_OT0050Context) || {};
  const navigate = useNavigate();

  const { access_token } = useSelector((state) => ({
    access_token: state.login.user.access_token,
  }));
  const csrfToken = useGetCsrfToken();

  const [formData, setFormData] = useState({
    cnpj: "",
    descricao: "",
    horarioInicio: "",
    horarioTermino: "",
    qtdVolume: "",
    valorMercadoria: "",
    pesoBruto: "",
    qtdVeiculos: "",
    limiteHorario: "",
    diasAnteriores: "",
    diasPosteriores: "",
    limiteAgendamentos: "",
    dataEncerramento: "",
    observacao: "",
    mostrarHorario: false,
  });

  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const formatHora = (value) => value?.replace(":", "") || null;

  const handleSave = useCallback(async () => {
    if (!formData.cnpj || !formData.descricao) {
      console.warn("Campos obrigatórios faltando (CNPJ e Descrição).");
      return;
    }

    try {
      if (setisLoading) setisLoading(true);

      const payload = {
        CNPJ_Local_Entrega: formData.cnpj.replace(/\D/g, "") || null,
        Descricao_Local_Entrega: formData.descricao || null,
        Horario_Inicio: formatHora(formData.horarioInicio),
        Horario_Termino: formatHora(formData.horarioTermino),
        Limite_Diario_Max_Volumes: parseInt(formData.qtdVolume) || null,
        Limite_Diario_Max_Valor: parseFloat(formData.valorMercadoria) || null,
        Limite_Diario_Max_Peso: parseFloat(formData.pesoBruto) || null,
        Limite_Diario_Max_Cubagem: null,
        Limite_Diario_Max_Veiculos: parseInt(formData.qtdVeiculos) || null,
        Limite_Max_Horario_Prog_Agendamento: formatHora(formData.limiteHorario),
        Limite_Min_Dias_Prog_Agendamento:
          parseInt(formData.diasAnteriores) || null,
        Limite_Max_Dias_Prog_Agendamento:
          parseInt(formData.diasPosteriores) || null,
        Limite_Agendamentos_Diarios_Parceiro:
          parseInt(formData.limiteAgendamentos) || null,
        Data_Encerramento: formData.dataEncerramento || null,
        ID_Calendario: null,
        ID_Empresa: idEmpresa ?? null,
        Observacao: formData.observacao || null,
        ID_Tipo_Local_Entrega: null,
        Mostra_Horario: formData.mostrarHorario ? "S" : "N",
      };

      await BizinBackend.executeProcedure(
        payload,
        "SRM_Agendamento_Insere_Locais_Entrega",
        csrfToken,
        access_token,
      );

      navigate("/DF_OT0050");
    } catch (error) {
      console.error("Erro ao gravar local de entrega:", error);
    } finally {
      if (setisLoading) setisLoading(false);
    }
  }, [
    formData,
    idEmpresa,
    setisLoading,
    setTriggerOnFilter,
    csrfToken,
    access_token,
    navigate,
  ]);

  return (
    <div style={{ padding: "0 10px" }}>
      <p className="text-muted font-size-14 mb-3 font-weight-bold">
        Informações do Local de Entrega
      </p>

      <Row className="gx-2 mb-0">
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="cnpj">CNPJ</Label>
            <Input
              type="text"
              id="cnpj"
              value={formData.cnpj}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="descricao">Descrição</Label>
            <Input
              type="text"
              id="descricao"
              value={formData.descricao}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="horarioInicio">Horário início</Label>
            <Input
              type="time"
              id="horarioInicio"
              value={formData.horarioInicio}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="horarioTermino">Horário término</Label>
            <Input
              type="time"
              id="horarioTermino"
              value={formData.horarioTermino}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row className="gx-2 mb-0">
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="qtdVolume">Quantidade volume</Label>
            <Input
              type="number"
              id="qtdVolume"
              value={formData.qtdVolume}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="valorMercadoria">Valor da mercadoria</Label>
            <Input
              type="number"
              id="valorMercadoria"
              value={formData.valorMercadoria}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="pesoBruto">Peso bruto (Kg)</Label>
            <Input
              type="number"
              id="pesoBruto"
              value={formData.pesoBruto}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="qtdVeiculos">Qtd. veículos</Label>
            <Input
              type="number"
              id="qtdVeiculos"
              value={formData.qtdVeiculos}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row className="gx-2 mb-0">
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="limiteHorario">Limite de horário</Label>
            <Input
              type="time"
              id="limiteHorario"
              value={formData.limiteHorario}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="diasAnteriores">Dias Anteriores dt. Entrega</Label>
            <Input
              type="number"
              id="diasAnteriores"
              value={formData.diasAnteriores}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="diasPosteriores">Dias Posteriores dt. Entrega</Label>
            <Input
              type="number"
              id="diasPosteriores"
              value={formData.diasPosteriores}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="limiteAgendamentos">
              Limite de Agendamentos Diários por Parceiro
            </Label>
            <Input
              type="number"
              id="limiteAgendamentos"
              value={formData.limiteAgendamentos}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row className="gx-2 mb-0">
        <Col lg={3}>
          <FormGroup className="mb-2">
            <Label for="dataEncerramento">Data de Encerramento</Label>
            <Input
              type="date"
              id="dataEncerramento"
              value={formData.dataEncerramento}
              onChange={handleInputChange}
              className={inputClassName}
            />
          </FormGroup>
        </Col>
        <Col lg={6}>
          <FormGroup className="mb-2">
            <Label for="observacao">Observação</Label>
            <Input
              type="textarea"
              id="observacao"
              value={formData.observacao}
              onChange={handleInputChange}
              rows="1"
              className={inputClassName}
              style={{ resize: "none" }}
            />
          </FormGroup>
        </Col>
        <Col lg={3}>
          <FormGroup check className="mt-4 pt-1">
            <Label check className="text-muted font-size-13">
              <Input
                type="checkbox"
                id="mostrarHorario"
                checked={formData.mostrarHorario}
                onChange={handleInputChange}
              />{" "}
              Mostrar horário de agendamento?
            </Label>
          </FormGroup>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col lg={12} className="d-flex justify-content-end">
          <Button
            className="btn-acao-gravar bg-primary-dark border-0 text-white font-w-600 rounded"
            onClick={handleSave}
          >
            Gravar
          </Button>
        </Col>
      </Row>
    </div>
  );
}
